import {
  ISearchHt,
  IStandardAPIResponse,
  IReadingStatus,
  IHTReading,
} from "../../vm";
import { httpClient, handleErrorResp } from "../UtilService";

export async function getHtReadings(
  obj: ISearchHt
): Promise<IStandardAPIResponse<Array<IHTReading>>> {
  try {
    let res = await httpClient<Array<IHTReading>>(`ht-readings`, "GET", obj);
    return res;
  } catch (err) {
    return handleErrorResp([]);
  }
}
export async function updateHtReadingStatus(
  obj: IReadingStatus
): Promise<IStandardAPIResponse<any>> {
  try {
    let res = await httpClient<any>(`ht-readings/status`, "PATCH", obj);
    return res;
  } catch (err) {
    return handleErrorResp([]);
  }
}
export async function UpdateHtReading(
  data: IHTReading
): Promise<IStandardAPIResponse<IHTReading>> {
  try {
    let res = await httpClient<IHTReading>(
      `ht-readings/${data._id}`,
      "PATCH",
      data
    );
    return res;
  } catch (err) {
    return handleErrorResp([]);
  }
}
